export const MODES = {
  CHANT: 'chant', 
  TEACHME: 'teach_me', 
} as const;

export interface Audio {
  file_path: { file_path: string;};
  mode: string;
}


export interface AudioCreate {
  file_path: { file_path: string;};
  mode: string;
}
// For POST and PUT (file uploads)
export interface AudioCreateOrUpdate {
  file_path: File | null;
  mode: string;
}
/* 
export interface AudioUpdate {
  file_path: { file_path: string;};
  mode: string;
}
 */

// Define the type for mode keys
export type ModeKey = keyof typeof MODES;

// Define the type for mode values
export type ModeValue = typeof MODES[ModeKey];